const _ = require('lib/underscore')

// all these URL inputs are the same except for the label
function url(element_attrs) {
    const attrs = {
        field_type: 'input',
        key: 'url',
        element: {
            placeholder: 'example.com',
        },
    }
    _.extend(attrs.element, element_attrs)
    return attrs
}

const buttonset = {
    field_type: 'buttonset',
    buttons: [
        {
            type: 'submit',
            label: 'Save',
            loading_label: 'Saving…',
            className: 'button fullwidth dark primary xlarge',
        },
    ],
}


const visit_list = [
    {
        id: 'attend_event',
        label: 'Attend my event',
        glyph: 'calendar',
        tweet_text(user) {
            return 'Attend my event from my @aboutdotme page! 📅👍'
        },
        fields: [
            url({ label: 'Enter a link to your event.' }),
            buttonset,
        ],
    },
    {
        id: 'back_campaign',
        label: 'Back my campaign',
        glyph: 'thumbsup',
        tweet_text(user) {
            return 'Back my campaign from my @aboutdotme page! 💸👍'
        },
        fields: [
            url({ label: 'Enter a link to your campaign page.' }),
            buttonset,
        ],
    },
    {
        id: 'download_app',
        label: 'Download my app',
        glyph: 'download-cloud',
        tweet_text(user) {
            return 'Download my app from my @aboutdotme page! 📲➡️'
        },
        fields: [
            url({ label: 'Enter a link to your app' }),
            buttonset,
        ],
    },
    {
        id: 'hire_me_link',
        label: 'Hire me',
        glyph: 'hireme',
        tweet_text(user) {
            return 'Hire me from my @aboutdotme page! 💼👍'
        },
        fields: [
            url({ label: 'Enter a link to your resume or portfolio.' }),
            buttonset,
        ],
    },
    {
        id: 'listen_music',
        label: 'Listen to my music',
        glyph: 'music',
        tweet_text(user) {
            return 'Listen to my music from my @aboutdotme page! 🎵🎹'
        },
        fields: [
            url({ label: 'Enter a link to your music or playlists.' }),
            buttonset,
        ],
    },
    {
        id: 'listen_podcast',
        label: 'Listen to my podcast',
        glyph: 'podcast',
        tweet_text(user) {
            return 'Listen to my podcast from my @aboutdotme page! 🗣🎙'
        },
        fields: [
            url({ label: 'Enter a link to your podcast.' }),
            buttonset,
        ],
    },
    {
        id: 'read_articles',
        label: 'Read my articles',
        glyph: 'doc',
        tweet_text(user) {
            return 'Read my articles from my @aboutdotme page! 📰🖥'
        },
        fields: [
            url({ label: 'Enter a link to your articles.' }),
            buttonset,
        ],
    },
    {
        id: 'read_blog',
        label: 'Read my blog',
        glyph: 'article',
        tweet_text(user) {
            return 'Read my blog from my @aboutdotme page! 👀🖥'
        },
        fields: [
            url({ label: 'Enter a link to your blog.' }),
            buttonset,
        ],
    },
    {
        id: 'read_book',
        label: 'Read my book',
        glyph: 'book',
        tweet_text(user) {
            return 'Read my book from my @aboutdotme page! 📗📖'
        },
        fields: [
            url({ label: 'Enter a link to your book.' }),
            buttonset,
        ],
    },
    {
        id: 'schedule_appt',
        label: 'Schedule an appointment',
        glyph: 'calendar',
        tweet_text(user) {
            return 'Schedule an appointment from my @aboutdotme page! 📅➡️'
        },
        fields: [
            url({ label: 'Enter a link.' }),
            buttonset,
        ],
    },
    {
        id: 'shop_store',
        label: 'Visit my store',
        glyph: 'shop',
        tweet_text(user) {
            return 'Visit my store from my @aboutdotme page! 👍🛍'
        },
        fields: [
            url({ label: 'Enter a link to your online store.' }),
            buttonset,
        ],
    },
    {
        id: 'sign_newsletter',
        label: 'Sign up for my newsletter',
        glyph: 'doc',
        tweet_text(user) {
            return 'Sign up for my newsletter from my @aboutdotme page! 📰📧'
        },
        fields: [
            url({ label: 'Enter a link to your newsletter form.' }),
            buttonset,
        ],
    },
    {
        id: 'stay_place',
        label: 'Stay at my place',
        glyph: 'place',
        tweet_text(user) {
            return 'Stay at my place from my @aboutdotme page! 🏡➡️'
        },
        fields: [
            url({ label: 'Enter a link to your rental property.' }),
            buttonset,
        ],
    },
    {
        id: 'support_charity',
        label: 'Support my charity',
        glyph: 'charity',
        tweet_text(user) {
            return 'Support my charity from my @aboutdotme page! 🎗💚'
        },
        fields: [
            url({ label: 'Enter a link to your favorite charity.' }),
            buttonset,
        ],
    },
    {
        id: 'take_class',
        label: 'Take my class',
        glyph: 'lightbulb',
        tweet_text(user) {
            return 'Take my class from my @aboutdotme page!💡🤓'
        },
        fields: [
            url({ label: 'Enter a link to your class or course.' }),
            buttonset,
        ],
    },
    {
        id: 'try_food',
        label: 'Try my food',
        glyph: 'food',
        tweet_text(user) {
            return 'Try my food from my @aboutdotme page! 🍽🍳'
        },
        fields: [
            url({ label: 'Enter a link to your recipe.' }),
            buttonset,
        ],
    },
    {
        id: 'view_company',
        label: 'Visit my company website',
        glyph: 'commercial-building',
        tweet_text(user) {
            return 'Visit my company website from my @aboutdotme page! 🏢🌐'
        },
        fields: [
            url({ label: 'Enter a link to your company website.' }),
            buttonset,
        ],
    },
    {
        id: 'view_listings',
        label: 'View my listings',
        glyph: 'home',
        tweet_text(user) {
            return 'View my listings from my @aboutdotme page! 🏡🏘'
        },
        fields: [
            url({ label: 'Enter a link to your listings.' }),
            buttonset,
        ],
    },
    {
        id: 'view_photos',
        label: 'View my photos',
        glyph: 'photos',
        tweet_text(user) {
            return 'View my photos from my @aboutdotme page! 📸👀'
        },
        fields: [
            url({ label: 'Enter a link to your photos.' }),
            buttonset,
        ],
    },
    {
        id: 'view_portfolio',
        label: 'View my portfolio',
        glyph: 'portfolio',
        tweet_text(user) {
            return 'View my portfolio from my @aboutdotme page! 📚👀'
        },
        fields: [
            url({ label: 'Enter a link to your portfolio.' }),
            buttonset,
        ],
    },
    {
        id: 'view_reel',
        label: 'Watch my reel',
        glyph: 'reel',
        tweet_text(user) {
            return 'Watch my reel from my @aboutdotme page! 📽🎞'
        },
        fields: [
            url({ label: 'Enter a link to your reel.' }),
            buttonset,
        ],
    },
    {
        id: 'view_repo',
        label: 'View my repo',
        glyph: 'code',
        tweet_text(user) {
            return 'View my repo from my @aboutdotme page! 💻⚒'
        },
        fields: [
            url({ label: 'Enter a link to your event.' }),
            buttonset,
        ],
    },
    {
        id: 'visit_restaurant',
        label: 'Visit my restaurant',
        glyph: 'restaurant',
        tweet_text(user) {
            return 'Visit my restaurant from my @aboutdotme page! 🍴🍝'
        },
        fields: [
            url({ label: 'Enter a link to your restaurant.' }),
            buttonset,
        ],
    },
    {
        id: 'visit_site',
        label: 'Visit my website',
        glyph: 'globe',
        default: true,
        tweet_text(user) {
            return 'Visit my website from my @aboutdotme page! 🖥📲'
        },
        fields: [
            url({ label: 'Enter a link to your website.' }),
            buttonset,
        ],
    },
    {
        id: 'watch_video',
        label: 'Watch my videos',
        glyph: 'video',
        tweet_text(user) {
            return 'Watch my videos from my @aboutdotme page! 🎥➡️'
        },
        fields: [
            url({ label: 'Enter a link to your videos.' }),
            buttonset,
        ],
    },
    {
        id: 'work_out',
        label: 'Work out with me',
        glyph: 'workout',
        tweet_text(user) {
            return 'Work out with me from my @aboutdotme page! 💪🏃'
        },
        fields: [
            url({ label: 'Enter a link to your fitness profile.' }),
            buttonset,
        ],
    },
    {
        id: 'vote_now',
        label: 'Vote now',
        glyph: 'checkbox',
        fields: [
            url({ label: 'Enter a link to your voter awareness page.' }),
            buttonset,
        ],
    },
    {
        id: 'register_to_vote',
        label: 'Register to vote',
        glyph: 'edit',
        fields: [
            url({ label: 'Enter a link to your voter registration website.' }),
            buttonset,
        ],
    },
    {
        id: 'support_candidate',
        label: 'Support my candidate',
        glyph: 'thumbsup',
        fields: [
            url({ label: 'Enter a link to your candidate’s website.' }),
            buttonset,
        ],
    },
]

// assign link mechanism
// all spotlights in this list are not premium
visit_list.forEach(spotlight => {
    spotlight.is_premium = false
    spotlight.mechanism = 'link'
    spotlight.group = 'visit'
})

module.exports = visit_list
